import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goregaontopunecab() {



const cardData = {
  keyword: " Goregaon to Pune Cab ",

headingDescription: "Velocity Cab provides reliable and comfortable Goregaon to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Goregaon to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Goregaon to Pune cab travel.",

topPlaces: [
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered spiritual landmarks dedicated to Lord Ganesha. Devotees and travelers can experience divine blessings, beautifully decorated idols, and a vibrant atmosphere, especially during major festivals like Ganesh Chaturthi."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification in Pune that once served as the seat of the Peshwas of the Maratha Empire. Visitors can explore its grand gateways, ruins, and enjoy the evening light and sound show that narrates Pune’s royal history."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden is a serene Japanese-style garden featuring lush greenery, water streams, and beautifully designed walking paths. It is an ideal place for relaxation, photography, and peaceful nature walks."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a historically significant monument linked to India’s freedom movement. It features elegant architecture, spacious gardens, and a museum dedicated to Mahatma Gandhi and important historical events."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a popular heritage site in Pune offering panoramic city views from its hilltop temples. Visitors can climb the steps to explore ancient shrines and enjoy a peaceful, scenic environment."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a well-known garden in Pune featuring lush green spaces and the famous Siddhivinayak Temple. It is a favorite spot for families, walkers, and visitors seeking relaxation in the city."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a riverside park offering greenery, walking tracks, and boating facilities. It is a peaceful location for evening strolls and leisure activities in Pune."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases a rich collection of Indian artifacts, including sculptures, musical instruments, and cultural items that reflect India’s heritage and traditions."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a popular shopping and entertainment hub featuring international brands, restaurants, cinemas, and entertainment zones, making it ideal for leisure and shopping experiences."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It is known for its spiritual ambiance and historical significance in Pune."
  }
],



services: [
{
name: "Goregaon to Pune Pimpri Chinchwad Cab",
description: "Goregaon to Pune Pimpri Chinchwad cab service provides reliable intercity transportation between Goregaon in Mumbai and the PCMC region including Pimpri and Chinchwad. Travelers can enjoy smooth travel through the Mumbai–Pune Expressway in comfortable vehicles such as sedan, Ertiga, and Innova. Professional drivers provide punctual pickup services from Goregaon East and West, residential societies, offices, and hotels. This service is ideal for business travelers visiting industrial areas and corporate offices in Pimpri Chinchwad. Air-conditioned vehicles ensure relaxed long-distance travel while spacious luggage capacity adds convenience for passengers. Online booking provides instant confirmation, transparent fares, and flexible travel schedules for comfortable journeys."
},
{
name: "Goregaon to Pune One Way Cab",
description: "Goregaon to Pune one way cab service offers affordable intercity transportation for travelers who require a single-direction trip without paying for return fares. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth highway travel via the Mumbai–Pune Expressway. Professional drivers offer timely pickup from homes, offices, and hotels in Goregaon. This service is widely used for airport transfers, corporate travel, and personal visits to Pune. Air-conditioned vehicles and spacious seating make the journey comfortable for passengers. Transparent pricing and online booking options ensure hassle-free travel planning."
},
{
name: "Goregaon to Pune Taxi Service",
description: "Goregaon to Pune taxi service provides dependable transportation between Goregaon and Pune city with comfortable vehicles and experienced drivers. Travelers can book rides from residential areas, commercial offices, railway stations, and hotels in Goregaon. Vehicles such as sedan, Ertiga, and Innova ensure smooth expressway travel and comfortable long-distance journeys. This taxi service is ideal for business trips, family visits, and airport transfers. Professional drivers ensure safe driving and punctual pickup services. Flexible booking options allow travelers to easily schedule trips according to their preferred time."
},
{
name: "Taxi Service in Goregaon Mumbai",
description: "Taxi service in Goregaon Mumbai offers convenient transportation for city travel, airport transfers, and outstation trips. Travelers can choose from comfortable vehicles such as sedan, Ertiga, and Innova depending on travel needs. Professional drivers provide safe and punctual pickups from Goregaon East and West, residential societies, hotels, and office complexes. This service is widely used for daily commuting and intercity journeys to destinations like Pune, Nashik, and Lonavala. Air-conditioned vehicles ensure comfortable rides while transparent pricing makes travel reliable and affordable."
},
{
name: "Cabs Service Goregaon Mumbai",
description: "Cabs service Goregaon Mumbai provides reliable taxi transportation for passengers traveling within the city and for outstation journeys. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth travel for airport transfers, business travel, and family trips. Professional drivers offer punctual pickups from homes, offices, and hotels across Goregaon. This service supports both short-distance city travel and long-distance journeys to Pune and nearby destinations. Flexible booking options allow travelers to schedule rides easily."
},
{
name: "Malad to Pune Cab Services",
description: "Malad to Pune cab service provides dependable transportation between Malad in Mumbai and Pune city. Comfortable vehicles including sedan, Ertiga, and Innova ensure smooth highway travel via the Mumbai–Pune Expressway. Professional drivers provide timely pickup services from homes, offices, and hotels in Malad. This taxi service is ideal for business travelers, families, and tourists heading to Pune. Air-conditioned vehicles and spacious seating ensure comfortable long-distance journeys. Online booking options make it easy to reserve rides instantly."
},
{
name: "Oshiwara Andheri to Pune Taxi Booking",
description: "Oshiwara Andheri to Pune taxi booking service offers convenient intercity transportation between Andheri’s Oshiwara area and Pune city. Comfortable vehicles such as sedan, Ertiga, and Innova provide smooth expressway travel. Professional drivers provide safe driving and punctual pickup services from homes, offices, and hotels in Oshiwara and Andheri. This service is ideal for corporate travel, airport transfers, and family trips. Spacious interiors and air-conditioning ensure comfortable journeys."
},
{
name: "Goregaon to Hinjewadi Cabs",
description: "Goregaon to Hinjewadi cab service provides reliable transportation between Mumbai and Pune’s major IT hub Hinjewadi. Comfortable vehicles ensure smooth expressway travel while professional drivers provide safe driving and punctual pickups. This service is widely used by IT professionals, corporate travelers, and business visitors heading to Hinjewadi Phase 1, Phase 2, and Phase 3. Spacious vehicles and air-conditioned interiors ensure comfortable long-distance journeys."
},
{
name: "Goregaon to Pune Station Cabs",
description: "Goregaon to Pune Station cab service offers dependable transportation between Goregaon and Pune Railway Station. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth expressway travel with experienced drivers handling highway routes safely. This service is ideal for passengers connecting to train journeys from Pune station. Travelers enjoy punctual pickups and comfortable long-distance rides with adequate luggage space."
},
{
name: "Goregaon to Pune Station Taxi Fare",
description: "Goregaon to Pune Station taxi fare service provides transparent pricing for passengers traveling from Goregaon to Pune Railway Station. Comfortable vehicles ensure smooth expressway travel while professional drivers provide safe driving and timely pickups. Clear fare details help passengers plan their travel budget easily."
},
{
name: "Taxi Services from Goregaon to Pune Station",
description: "Taxi services from Goregaon to Pune Station provide reliable transportation between Mumbai and Pune Railway Station. Travelers can choose comfortable vehicles such as sedan, Ertiga, and Innova for convenient travel. Professional drivers ensure punctual pickups and safe expressway driving."
},
{
name: "Innova Crysta on Rent Goregaon Mumbai",
description: "Innova Crysta on rent in Goregaon Mumbai provides premium SUV transportation for passengers seeking comfort and spacious travel. Toyota Innova Crysta vehicles offer luxurious interiors, comfortable seating, and smooth highway performance. This service is ideal for airport transfers, corporate travel, and outstation trips to Pune and nearby cities."
},
{
name: "Cabs Service in Goregaon",
description: "Cabs service in Goregaon offers convenient taxi transportation for city travel, airport transfers, and outstation trips. Travelers can book comfortable vehicles with experienced drivers for reliable transportation. This service supports daily commuting as well as long-distance journeys."
},
{
name: "Innova Crysta on Rent in Goregaon Mumbai",
description: "Innova Crysta rental service in Goregaon Mumbai offers spacious SUV travel for families, corporate travelers, and group journeys. These vehicles provide excellent comfort for long-distance trips to Pune and nearby cities. Professional drivers ensure safe and smooth travel."
},
{
name: "Goregaon to Pimpri Chinchwad Cab",
description: "Goregaon to Pimpri Chinchwad cab service offers reliable transportation between Mumbai and PCMC areas. Comfortable vehicles ensure smooth expressway travel while professional drivers provide safe driving and punctual pickups."
},
{
name: "Goregaon to Pimpri Chinchwad Cab Fare",
description: "Goregaon to Pimpri Chinchwad cab fare service provides clear pricing information for travelers planning intercity travel. Passengers can choose vehicles according to comfort and budget preferences while enjoying transparent fares."
},
{
name: "Goregaon to Swargate Cab",
description: "Goregaon to Swargate cab service provides dependable transportation between Goregaon and central Pune. Comfortable vehicles ensure smooth expressway travel while professional drivers provide punctual pickups."
},
{
name: "Cab Services in Goregaon Mumbai",
description: "Cab services in Goregaon Mumbai provide reliable taxi transportation for passengers traveling within the city or heading to nearby destinations. Comfortable vehicles and experienced drivers ensure safe journeys."
},
{
name: "Taxi Service in Goregaon for Outstation",
description: "Taxi service in Goregaon for outstation travel provides long-distance transportation to cities like Pune, Nashik, and Lonavala. Comfortable vehicles and experienced drivers ensure safe highway travel."
},
{
name: "Goregaon to Pune Cab",
description: "Goregaon to Pune cab service offers reliable intercity transportation between Mumbai and Pune. Comfortable vehicles ensure smooth expressway travel while professional drivers provide safe driving and punctual pickups."
},
{
name: "Goregaon to Pune Taxi",
description: "Goregaon to Pune taxi service provides convenient transportation between the two cities with comfortable vehicles and experienced drivers ensuring smooth highway journeys."
},
{
name: "Goregaon to Pune Cab Service",
description: "Goregaon to Pune cab service provides dependable long-distance transportation between Mumbai and Pune. Travelers enjoy comfortable vehicles, experienced drivers, and smooth expressway travel."
},
{
name: "Goregaon to Pune Taxi Booking",
description: "Goregaon to Pune taxi booking allows passengers to reserve taxis easily through online platforms. Travelers can select vehicle types and schedule pickup times conveniently."
},
{
name: "Goregaon to Pune Drop Taxi",
description: "Goregaon to Pune drop taxi service offers convenient one-way transportation between the two cities with economical fares and comfortable vehicles."
}
],

tableData: [
["Goregaon to Pune Pimpri Chinchwad Cab","Goregaon to Pune One Way Cab"],
["Goregaon to Pune Taxi Service","Taxi Service in Goregaon Mumbai"],
["Cabs Service Goregaon Mumbai","Malad to Pune Cab Services"],
["Oshiwara Andheri to Pune Taxi Booking","Goregaon to Hinjewadi Cabs"],
["Goregaon to Pune Station Cabs","Goregaon to Pune Station Taxi Fare"],
["Taxi Services from Goregaon to Pune Station","Innova Crysta on Rent Goregaon Mumbai"],
["Cabs Service in Goregaon","Innova Crysta on Rent in Goregaon Mumbai"],
["Goregaon to Pimpri Chinchwad Cab","Goregaon to Pimpri Chinchwad Cab Fare"],
["Goregaon to Swargate Cab","Cab Services in Goregaon Mumbai"],
["Taxi Service in Goregaon for Outstation","Goregaon to Pune Cab"],
["Goregaon to Pune Taxi","Goregaon to Pune Cab Service"],
["Goregaon to Pune Taxi Booking","Goregaon to Pune Drop Taxi"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Goregaon to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Goregaon to Pune cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Goregaon to Pune cab service operates 24 hours a day. Whether you need an early morning ride, airport transfer, or late night travel, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Goregaon to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Goregaon",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and residential areas across Goregaon including Goregaon East, Goregaon West, and nearby locations."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Goregaon to Pune cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Goregaon to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Goregaon to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Goregaon from Pune?", answer: "The road distance between Goregaon and Pune is approximately 150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Goregaon to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Goregaon to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Goregaon to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Goregaon and Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, railway stations, and residential areas across Goregaon." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Goregaon to Pune cab services online or through phone booking." },
  { question: "Do you provide drop service to Pune Airport or railway station?", answer: "Yes, Velocity Cabs provides drop services to Pune Airport, railway stations, and major locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Patil",
    feedback:
      "The Goregaon to Pune journey was very comfortable and well-planned. The cab arrived on time, the vehicle was clean, and the ride was smooth throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "Traveling from Goregaon to Pune was a great experience. The service was punctual, the driver was polite, and the entire trip felt safe and relaxed.",
    rating: 5
  }
];

































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Goregaon to Pune Cab Service | Velocity Cabs",
  "description": "Velocity Cabs offers reliable Goregaon to Pune cab service with professional drivers and affordable fares. Book one way or round trip taxis including Innova, Innova Crysta, Ertiga, and Sedan cabs for city-to-city travel, airport transfers, and corporate trips. Enjoy safe, comfortable, and punctual rides with easy online booking from Goregaon to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Goregaon to Pune Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Goregaon to Pune cab with Velocity Cabs. Affordable one way & round trip taxis including Innova, Innova Crysta, Ertiga & Sedan for city travel, airport transfers & corporate trips." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/46.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Goregaontopunecab;